import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';
import {
  FETCH_HOME_INSIGHTS_LOCATIONS,
  FETCH_HOME_INSIGHTS_LOCATIONS_ERROR,
  SET_HOME_INSIGHTS_LOCATIONS,
} from '../../constants';

const homeInsightsLocations = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_HOME_INSIGHTS_LOCATIONS),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/home/locations?${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_HOME_INSIGHTS_LOCATIONS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_HOME_INSIGHTS_LOCATIONS_ERROR,
            error,
          })
        )
      )
    )
  );

export default homeInsightsLocations;
